<template>
  <div class="order-page">
    <div class="container">
      <search-part ref="searchPart" :bizTypes="bizTypes" :orgType="orgType" :activeStatus="activeStatus" @add="add"
                   @editShowType="editShowType" @editFilters="editFilters" @refresh="refresh"/>
      <el-row v-show="!isNeed">
        <el-col :span="16">
          <div class="order-list-status " style="margin-bottom:20px" v-show="showType">
            <div class="status-item" :class="{'active':key===activeStatus}"
                 v-for="(item,key) in orgType" :key="item.key" @click="changeStatus(item,key)">
              <div class="status-bg" :class="['b_color_'+key]"></div>
              <div><i class="el-icon-caret-right" v-if="key===activeStatus"></i>{{item.title}}<span
                class="status-num">{{item.num}}</span></div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="order-list">
        <el-row class="order-list-header">
          <el-col :span="isNeed ? 5 : 6" style="padding-left: 2px">
            货主/订单号
          </el-col>
          <el-col :span="2">业务类型</el-col>
          <el-col :span="5">{{isNeedOrder ? '来源' : $formatOrderType(type)}}/订单号</el-col>
          <el-col :span="3">物流方式</el-col>
          <el-col :span="4">时间</el-col>
          <el-col :span="2">状态</el-col>
          <el-col :span="isNeed ? 3 : 2">操作</el-col>
        </el-row>
        <el-row v-if="loadingData">
          <el-col :span="24">
            <oms-loading :loading="loadingData"></oms-loading>
          </el-col>
        </el-row>
        <el-row v-else-if="!orderList.length">
          <el-col :span="24">
            <div class="empty-info">
              暂无信息
            </div>
          </el-col>
        </el-row>
        <div v-else="" class="order-list-body flex-list-dom">
          <div class="order-list-item order-list--no is-pointer" v-for="(item, index) in orderList" :key="item.id"
               @click.prevent="showItem(item)"
               :class="['status-'+ filterListColor(item.status),{'active':currentOrderId===item.id}]">
            <el-row>
              <el-col :span="isNeed ? 5 : 6">
                <div class="f-grey">
                  {{item.orderNo }}
                </div>
                <div>
                  {{item.upstreamOrgName }}
                </div>
              </el-col>
              <el-col :span="2">
                <dict dict-group="orderGoodsType" :dict-key="'' + item.orderGoodsType"></dict>
                <div>
                  <dict dict-group="bspBizType" :dict-key="item.bizType"></dict>
                </div>
              </el-col>
              <el-col :span="5">
                <div class="f-grey" v-show="item.orderThirdNo">{{item.orderThirdNo }}</div>
                <div v-show="item.downstreamOrgName">{{item.downstreamOrgName}}</div>
              </el-col>
              <el-col :span="3">
                <div v-show="item.transportationMeans">
                  <dict :dict-group="type === 0 ? 'transportationMeans' : 'outTransportMeans'"
                        :dict-key="item.transportationMeans"></dict>
                </div>
                <!--<div v-show="item.shippingAddress">{{ item.shippingAddress}}</div>-->
              </el-col>
              <el-col :span="4">
                <div v-show="item.createTime">下单：{{item.createTime | time }}</div>
                <div v-show="item.expectedTime">预计入库：{{ item.expectedTime | date}}</div>
                <div v-show="item.completeTime">完成：{{ item.completeTime | time}}</div>
              </el-col>
              <el-col :span="2">
                {{getOrderStatus(item)}}
              </el-col>
              <el-col :span="isNeed ? 3: 2">
                <div v-show="!isNeed">
                  <des-btn custom icon="edit" @click="edit(item)" v-show="filters.status === '0'" :perm="perm.edit">编辑
                  </des-btn>
                  <des-btn @click="review(item, '1')" custom icon="review" perm="bsp-order-org-review"
                           v-show="item.status === '4'">复核
                  </des-btn>
                  <des-btn @click="review(item, '0')" custom icon="allot" perm="bsp-order-org-review"
                           v-show="item.status === '3'">收货
                  </des-btn>
                </div>
                <div v-show="isNeedOrder">
                  <des-btn @click="transformOrderItem(item)" custom icon="xiaoshou"
                           perm="bsp-out-order-org-add">生成销售订单
                  </des-btn>
                </div>
                <div v-show="isPurchaseReturnOrder">
                  <des-btn @click="transformReturnOrderItem(item)" custom icon="sale-return"
                           perm="bsp-out-order-org-add">生成销退订单
                  </des-btn>
                </div>
              </el-col>
            </el-row>
            <goods-info :order-item="item"></goods-info>
            <div class="order-list-item-bg" v-show="!isNeed"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center" v-show="(orderList.length  || pager.currentPage !== 1) && !loadingData">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="pager.currentPage"
                     :page-sizes="[10,20,50,100]" :page-size="pager.pageSize" layout="sizes, prev, pager, next, jumper"
                     :total="pager.count">
      </el-pagination>
    </div>
    <page-right :show="!!defaultIndex" @right-close="resetRightBox" :css="{'width':dialogWidth +'px','padding':0}"
                class="order-detail-info specific-part-z-index" partClass="pr-no-animation">
      <detail :orderId="currentOrderId" @refresh="refresh" :defaultIndex="defaultIndex"
              v-show="defaultIndex === 1"></detail>
      <form-part :orderId="currentOrderId" :defaultIndex="defaultIndex" v-show="[2, 3].includes(defaultIndex)"
                 @refresh="refresh"/>
      <review :defaultIndex="defaultIndex" :orderId="currentOrderId" @refresh="refresh" :type="reviewType"
              v-show="defaultIndex === 4"/>
      <transform-order :orderId="currentOrderId" :defaultIndex="defaultIndex" @refresh="refresh"
                       v-show="defaultIndex === 5"/>
    </page-right>
  </div>
</template>
<script>
  import utils from '@/tools/utils';
  import {BSPOrder} from '@/resources';
  import goodsInfo from '@/components/common/order/order-goods-info';
  import orderMixin from '@/mixins/orderMixin';
  import Detail from './detail/index.vue';
  import SearchPart from './search';
  import FormPart from './form';
  import review from './review/review';
  import transformOrder from './form/transformOrder';

  export default {
    components: {
      goodsInfo, Detail, SearchPart, FormPart, review, transformOrder
    },
    mixins: [orderMixin],
    data: function () {
      return {
        querying: false,
        loadingData: true,
        showSearch: false,
        orderList: [],
        showType: true,
        filters: {
          type: 0,
          status: '0'
        },
        orgType: {},
        activeStatus: '1',
        currentOrderId: '',
        pager: {
          currentPage: 1,
          count: 0,
          pageSize: parseInt(window.localStorage.getItem('currentPageSize'), 10) || 10
        },
        defaultIndex: 0,
        user: {},
        dialogWidth: 1100,
        reviewType: '1'
      };
    },
    mounted() {
      this.getOrderList(1);
      this.user = JSON.parse(localStorage.getItem('user'));
      let orderId = this.$route.params.orderId;
      if (orderId) {
        this.currentOrderId = orderId;
        this.defaultIndex = 1;
        this.dialogWidth = 1100;
      }
      this.initValue();
    },
    computed: {
      isShowGoodsList() {
        return this.$store.state.isShowGoodsList;
      },
      perm() {
        return this.$route.meta.pagerPerm;
      },
      isNeed() {
        return this.$route.meta.isNeed || this.$route.meta.isPurchaseReturn;
      },
      isNeedOrder() {
        return this.$route.meta.isNeed;
      },
      isPurchaseReturnOrder() {
        return this.$route.meta.isPurchaseReturn;
      }
    },
    watch: {
      filters: {
        handler: function () {
          if (!this.showType || this.querying) return;
          this.getOrderList(1);
        },
        deep: true
      },
      isShowGoodsList() {
        if (this.querying) return;
        this.getOrderList(1);
      },
      type() {
        if (this.querying) return;
        this.refresh();
        this.initValue();
        this.getOrderList(1);
      },
      role() {
        if (this.querying) return;
        this.initValue();
        this.getOrderList(1);
      },
      isNeed() {
        if (this.querying) return;
        this.initValue();
        this.getOrderList(1);
      }
    },
    methods: {
      initValue() {
        this.activeStatus = '1';
        this.filters = {
          status: '0',
          type: this.$route.meta.type
        };
        this.showSearch = false;
        this.orgType = utils[this.type === 0 ? 'inBspOrderType' : 'outBspOrderType'];
        // 清空查询参数
        this.$refs.searchPart.resetForm();
      },
      editShowType(val) {
        this.showType = val;
      },
      editFilters(val) {
        Object.assign(this.filters, val);
      },
      refresh() {
        this.getOrderList(1);
        this.resetRightBox();
      },
      getNo(index) {
        return ('' + index).split('');
      },
      changeStatus: function (item, key) {// 订单分类改变
        this.activeStatus = key;
        this.filters.status = item.status;
      },
      handleSizeChange(val) {
        this.pager.pageSize = val;
        window.localStorage.setItem('currentPageSize', val);
        this.getOrderList(1);
      },
      handleCurrentChange(val) {
        this.getOrderList(val);
      },
      getOrderStatus: function (order) {
        let status = '';
        for (let key in this.orgType) {
          if (order.status === this.orgType[key].status) {
            status = this.orgType[key].title;
          }
        }
        return status;
      },
      resetRightBox: function () {
        this.defaultIndex = 0;
        if (this.isNeedOrder) {
          this.$route.meta.type = 0;
        }
        if (this.isPurchaseReturnOrder) {
          this.$route.meta.type = 1;
        }
      },
      onSubmit: function (order) {
        this.currentOrderId = '';
        this.getOrderList(1);
      },
      getOrderList: function (pageNo) {
        if (this.$route.meta.type !== this.filters.type) return;
        this.pager.currentPage = pageNo;
        let param = {};
        param = Object.assign({}, this.filters, {
          pageNo: pageNo,
          pageSize: this.pager.pageSize
        });
        if (!this.showType) {
          param.searchType = 1;
        }
        // 明细查询
        param.showDetailFlag = !!JSON.parse(window.localStorage.getItem('isShowGoodsList'));
        // 非急单,不传此参数
        if (!param.rushOrderFlag) {
          delete param.rushOrderFlag;
        }
        if (this.isNeedOrder) {
          param.status = '3';
          if (param.type === 1) return;
        }
        if (this.isPurchaseReturnOrder) {
          param.status = '4';
          if (param.type === 0) return;
        }
        this.querying = true;
        this.time = Date.now();
        const time = this.time;
        this.loadingData = true;
        BSPOrder.queryLogisticsOrder(param).then(res => {
          if (time < this.time) return;
          res.data.list.forEach(i => {
            i.isChecked = false;
          });
          this.orderList = res.data.list;
          // 设置分页数
          this.pager.count = res.data.count;
          this.loadingData = false;
          this.querying = false;
        }).catch(err => {
          this.querying = false;
        });
        if (!this.showType) return;
        this.queryStatusNum(param);
      },
      filterListColor: function (status) {// 过滤左边列表边角颜色
        let index = '';
        for (let key in this.orgType) {
          if (status === this.orgType[key].status) {
            index = key;
          }
        }
        return index;
      },
      queryStatusNum: function (params) {
        let httpRequest = BSPOrder['queryLogisticsOrderCount'](Object.assign({}, params, {status: null}));
        this.numTime = Date.now();
        const time = this.numTime;
        httpRequest.then(res => {
          if (time < this.numTime) return;
          let data = res.data;
          let type = JSON.parse(JSON.stringify(this.orgType));
          Object.keys(type).forEach(i => {
            let item = data.find(f => f.status === type[i].status);
            type[i].num = item && item.count || 0;
          });
          this.orgType = type;
        });
      },
      showItem: function (order) {
        this.currentOrderId = '';
        this.$nextTick(() => {
          this.currentOrderId = order.id;
          this.defaultIndex = 1;
          this.dialogWidth = 1100;
        });
      },
      add() {
        this.defaultIndex = 2;
        this.dialogWidth = 1000;
      },
      edit(row) {
        this.currentOrderId = row.id;
        this.defaultIndex = 3;
        this.dialogWidth = 1000;
      },
      review(row, type) {
        this.currentOrderId = row.id;
        this.defaultIndex = 4;
        this.dialogWidth = 800;
        this.reviewType = type;
      },
      transformOrderItem(row) {
        this.$route.meta.type = 1;
        this.currentOrderId = row.id;
        this.defaultIndex = 5;
        this.dialogWidth = 1000;
      },
      transformReturnOrderItem(row) {
        this.$route.meta.type = 0;
        this.currentOrderId = row.id;
        this.defaultIndex = 5;
        this.dialogWidth = 1000;
      }
    }
  };
</script>
